export const legacyContractProductGroups = [{ id: 'mock-group', name: 'Mock 그룹' }]
export const legacyContractProductOffices = [{ id: 'mock-office', name: 'Mock 지점' }, { id: 'mock-office-2', name: 'Mock 테스트 지점' }]
export const legacyContractProductRows = Array.from({ length: 4 }, (_, index) => ({
  id: `MOCK-CONTRACT-${index + 1}`,
  no: index + 1,
  date: '0000-00-00',
  packageName: `Mock 패키지 ${index + 1}`,
  productName: `Mock 상세상품 ${index + 1}`,
  customerNo: `MOCK-${String(index + 1).padStart(3, '0')}`,
  oldNo: '-',
  baby: '아기◯',
  mother: '보호자◯',
  phone: '010-0000-0000',
  father: '보호자◯',
}))
export const legacyContractProductTypes = ['촬영', '앨범', '액자', '기타상품', '파일', '메이크업', '의상대여']
export const legacyContractProductOptions = ['Mock 촬영상품', 'Mock 앨범상품', 'Mock 액자상품']
